import { createStyles, Group } from '@mantine/core';
import React, { useMemo } from 'react';

import { Notifications } from './Notifications';
import { ProductUpdates } from './ProductUpdates';
import { QuickSearch } from './QuickSearch';
import { UserSettings } from './UserSettings';
import { useAppConfig } from '../../../context';
import { HubsMenu } from '../sidebar/tenant-menu/hubs-menu/HubsMenu';

export function HubsNavbar() {
  const { classes } = useStyles();
  const { extraLayout = {} } = useAppConfig();
  const { navbarLayout, options = {} } = extraLayout;

  const content = useMemo(
    () => (
      <Group
        position="right"
        align="center"
        spacing="xs"
        className={classes.container}
        bg="midnight_blue_accent.4"
      >
        {options.isMobile ? null : <QuickSearch />}

        {navbarLayout ? navbarLayout() : null}

        <ProductUpdates />

        <Notifications />

        <UserSettings />
      </Group>
    ),
    [classes.container, navbarLayout, options.isMobile]
  );

  return (
    <Group
      position="apart"
      align="center"
      className={classes.wrapper}
      bg="midnight_blue_accent.4"
    >
      <HubsMenu />

      {content}
    </Group>
  );
}

const useStyles = createStyles((theme) => ({
  wrapper: {},
  container: {
    padding: '10px 12px',
    height: theme.other.navbarHeight,

    li: {
      listStyle: 'none',
    },

    path: {
      stroke: `${theme.colors.blue_gray[2]} !important`,
    },
  },
}));
